export default __webpack_public_path__ + "static/media/burgerMenuLight.151ef2b7.svg";